import React from "react";
import PropTypes from "prop-types";
import Masonry from "react-masonry-css";
import Img from "gatsby-image";
import RecommendationBlock from "./../RecommendationBlock";
import { TeamCardHolderDiv, TeamCard, OverlayDiv, Scrim } from "./elements";
import { H3Strong, H3, H5Medium, H4Strong, H5 } from "./../Typography";
import CloseButton from "./../icons/CloseButton";
import MiscSocialSmall from "./../icons/MiscSocialSmall";

//TODO: icons for individual social media rather than MiscSocialSmall

const Overlay = ({
  person,
  photoCoordinates,
  holderCoordinates,
  recommendation,
  closeThis,
}) => {
  // console.log(recommendation);
  // console.log(person);
  // console.log(holderCoordinates);
  // console.log(photoCoordinates);
  const myLeft = photoCoordinates.x - holderCoordinates.x - 50;
  const myTop = photoCoordinates.top - holderCoordinates.top - 88;
  return (
    <OverlayDiv left={myLeft} top={myTop}>
      <div>
        <div>
          {person.ourPeopleHeadshot[0].wideImage.childImageSharp ? (
            <Img
              fixed={
                person.ourPeopleHeadshot[0].wideImage.childImageSharp.fixed
              }
              alt={person.title}
            />
          ) : (
            <img
              src={person.ourPeopleHeadshot[0].wideImage.publicURL}
              alt={person.title}
            />
          )}
          <H4Strong>Contact Details</H4Strong>
          <div>
            {person.communityMemberContactDetails &&
            person.communityMemberContactDetails.length
              ? person.communityMemberContactDetails.map((method, index) => (
                  <p key={index}>
                    {method.method} {method.value}
                  </p>
                ))
              : null}
            <MiscSocialSmall color={"var(--green)"} />
          </div>
        </div>
        <div>
          <H3Strong>{person.title}</H3Strong>
          <H3>{person.ourPeopleTitle}</H3>
          <div dangerouslySetInnerHTML={{ __html: person.richTextField }} />
        </div>
      </div>
      {recommendation ? (
        <RecommendationBlock
          name={recommendation.recommendationName[0]}
          events={recommendation.recommendationEvents}
          accentColor={"var(--green)"}
        />
      ) : null}
      <CloseButton
        color={"var(--green)"}
        hoverColor={"var(--black)"}
        onClick={closeThis}
      />
    </OverlayDiv>
  );
};

const TeamCardHolder = ({ cards, recommendations, openTo }) => {
  const [currentlySelected, setCurrentlySelected] = React.useState(null);
  const [overlayOn, setOverlayOn] = React.useState(false);
  const holderRef = React.useRef(null);
  // console.log(cards);
  // TODO: offset randomly

  const getRecommendationDataForSlug = (slug) =>
    recommendations.filter((x) => x.recommendationName[0].slug === slug).length
      ? recommendations.filter((x) => x.recommendationName[0].slug === slug)[0]
      : null;

  React.useLayoutEffect(() => {
    // console.log("firing layout effect!");
    // console.log(openTo);
    if (openTo) {
      setCurrentlySelected(openTo);
      setOverlayOn(true);
    }
  }, []);

  return (
    <TeamCardHolderDiv ref={holderRef}>
      <Masonry
        breakpointCols={{ default: 4, 1270: 3, 950: 2, 635: 1 }}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {cards.map((card, index) => (
          <TeamCard
            key={index}
            onClick={(e) => {
              e.preventDefault();
              setCurrentlySelected(card);
              setOverlayOn(true);
            }}
          >
           <a
              href="/#"
              onClick={(e) => {
                e.preventDefault();
              }}
            >  
              {card.ourPeopleHeadshot[0].wideImage.childImageSharp ? (
                <div id={card.slug}>
                  <Img
                    fixed={
                      card.ourPeopleHeadshot[0].wideImage.childImageSharp.fixed
                    }
                  />
                </div>
              ) : (
                <img
                  src={card.ourPeopleHeadshot[0].wideImage.publicURL}
                  id={card.slug}
                />
              )}
              <H5Medium>{card.title}</H5Medium>
              <H5>{card.ourPeopleTitle}</H5>
            </a>
          </TeamCard>
        ))}
      </Masonry>
      {overlayOn ? (
        <Scrim
          onClick={(e) => {
            setOverlayOn(false);
          }}
        />
      ) : null}
      {overlayOn ? (
        <Overlay
          person={currentlySelected}
          photoCoordinates={holderRef.current
            .querySelector(`#${currentlySelected.slug}`)
            .getBoundingClientRect()}
          holderCoordinates={holderRef.current.getBoundingClientRect()}
          recommendation={getRecommendationDataForSlug(currentlySelected.slug)}
          closeThis={() => {
            setOverlayOn(false);
          }}
        />
      ) : null}
    </TeamCardHolderDiv>
  );
};

export default TeamCardHolder;

TeamCardHolder.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      communityMemberSlug: PropTypes.string,
      title: PropTypes.string,
      slug: PropTypes.string,
      richTextField: PropTypes.string,
      ourPeopleTitle: PropTypes.string,
    })
  ),
};
